/**
 * The following things will need to be fixed:
 *  - Async loading of the locales or only include the locale necessary for a bundle
 *  - Grab the user locale from somewhere other than the AJS meta.
 */
import * as en from 'date-fns/locale/en';
import * as de from 'date-fns/locale/de';
import * as es from 'date-fns/locale/es';
import * as fr from 'date-fns/locale/fr';
import * as ja from 'date-fns/locale/ja';
import * as ko from 'date-fns/locale/ko';
import * as pt from 'date-fns/locale/pt';
import * as ru from 'date-fns/locale/ru';
import * as cs from 'date-fns/locale/cs';
import * as fi from 'date-fns/locale/fi';
import * as hu from 'date-fns/locale/hu';
import * as it from 'date-fns/locale/it';
import * as ro from 'date-fns/locale/ro';
import * as sk from 'date-fns/locale/sk';
import * as da from 'date-fns/locale/da';
import * as is from 'date-fns/locale/is';
import * as nl from 'date-fns/locale/nl';
import * as pl from 'date-fns/locale/pl';
import * as sv from 'date-fns/locale/sv';
import { format as dateFnsFormat } from 'date-fns';
import * as AJS from 'util/ajs';

const supportedLocale = { en, de, es, fr, ja, ko, pt, ru, cs, fi, hu, it, ro, sk, da, is, nl, pl, sv };

export const format: (date: Date | string | number, dateTimeFormat: string | undefined) => string = (
    date,
    dateTimeFormat
) => {
    const localeKeys = (AJS.getMeta('user-locale') || '').replace('_', '-').split('-');
    if (localeKeys && localeKeys.length > 0) {
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        const localeToUse = supportedLocale[localeKeys[0]];
        return dateFnsFormat(date, dateTimeFormat, {
            locale: localeToUse,
        });
    }

    return dateFnsFormat(date, dateTimeFormat);
};

type DayRange = 0 | 1 | 2 | 3 | 4 | 5 | 6;

const isValidWeekRange = (firstDay: number | undefined): firstDay is DayRange => {
    return (firstDay as DayRange) >= 0 && (firstDay as DayRange) <= 6;
};

export const getDayOfTheWeek = (firstDay: number | undefined): 0 | 1 | 2 | 3 | 4 | 5 | 6 | undefined => {
    if (isValidWeekRange(firstDay)) return firstDay;
    return undefined;
};

export const getWeekStartDay = (firstDay?: number, useISO8601WeekNumbers?: boolean) => {
    return useISO8601WeekNumbers ? 1 : getDayOfTheWeek(firstDay);
};
